import {
  EXPAND_SIDE_MENU,
  COLLAPSE_SIDE_MENU
} from '../actionTypes/sideMenu'

// The initial state of the App
export const initialState = {
  isSideMenuExpanded: true,
}

const sideMenu = (state = initialState, action) => {
  switch (action.type) {
    case EXPAND_SIDE_MENU:
      return {
        ...state,
        isSideMenuExpanded: true
      };
    case COLLAPSE_SIDE_MENU:
      return {
        ...state,
        isSideMenuExpanded: false
      }
    default:
      return state
  }
}

export default sideMenu
